var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"button-view-document",attrs:{"plain":"","data-test":`button-view-document-${_vm.rowIndex}`},on:{"click":_vm.viewDocument}},[_c('e-svg-icon',{attrs:{"name":"eye"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }